import keymirror from 'keymirror';

export const PrintableTypes = keymirror({
  personal: null,
  generic: null,
  custom: null,
});
